export default __webpack_public_path__ + "static/kawung-c44e84f6b73323709a11f656d91a53bd.svg";